module.exports = __webpack_public_path__ + "img/flow-chart.be59a7ae.png";